/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/order */
/* eslint-disable import/no-duplicates */
/* eslint-disable prettier/prettier */
import React, { useEffect, useRef, useState } from 'react'
import {
  FormControlLabel,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  Box,
} from '@material-ui/core'
import { IconButton, makeStyles } from '@material-ui/core'
import { Grid, Paper, Typography } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import ThumbDownAltOutlinedIcon from '@material-ui/icons/ThumbDownAltOutlined'
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUp'
import { PhotoCamera } from '@material-ui/icons'
import ReactInputMask from 'react-input-mask'
import ufs from '../../../../util/uf'
import { isCpfCnpjValid } from '../../../../util/cpf_cnpj_validator'
import config from '../../../../config'
import colors from '../../../../assets/colors'
import Icon from '@mdi/react'
import { mdiProgressUpload } from '@mdi/js'
import { useDispatch, useSelector } from 'react-redux'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { format, parseISO } from 'date-fns'
import { Flag } from '../../../components/Menu/TenantLocaleFlag'
import { fetchLocaleOptions } from '../../LaundryClientActions'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '.5rem',
    // border: '1px solid #539fdd',
  },
  row: {
    width: '100%',
    padding: '.5rem',
  },
  uploadLogo: {
    width: '100%',
    height: '100%',
    border: `1px dashed ${colors.primary}`,
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    fontSize: '14px',
    borderRadius: '10px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: '#FFF',
      opacity: '.6',
    },
  },
  logo: {
    objectFit: 'cover',
    width: '169px',
    maxHeight: '60px',
    borderRadius: '10px',
  },
  logoValidate: {
    fontSize: '12px',
    color: colors.graylight,
  },
  countryOption: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  regionCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '6px 12px',
    borderRadius: '8px',
    border: `1px solid ${colors.grayMedium}`,
  },
  regionFlag: {
    borderRadius: 3,
  },
  regionInfo: {
    flex: 1,
    minWidth: 0,
  },
  regionTitle: {
    fontSize: '10px',
    fontWeight: 700,
    color: colors.primary,
    textTransform: 'uppercase',
    letterSpacing: '.04em',
  },
  regionHint: {
    marginTop: '2px',
    fontSize: '11px',
    color: colors.textGray,
  },
})

const FormGroupLaundry = ({ form, setForm, handleChange }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [countries, setCountries] = useState([])
  const [locales, setLocales] = useState([])

  const statuses = useSelector(state => state.laundryClient.statuses)
  const trialPeriodDays = useSelector(
    state => state.laundryClient.trial_period_days
  )

  const [mask, setMask] = useState('999.999.999-99')

  const [cpfCnpj, setCpfCnpj] = useState({
    error: false,
    text: 'Digite um CPF ou CNPJ',
  })

  const [logoValidate, setLogoValidate] = useState({
    invalidType: '',
  })

  const inputRef = useRef()

  const handlePhoneChange = e => {
    const { name, value } = e.target
    const phoneWithoutMask = value.replace(/\D/g, '')

    setForm({
      ...form,
      [name]: phoneWithoutMask,
    })
  }

  const handleChangeLogo = event => {
    const { files } = event.target

    if (!files[0]) return

    const image = event.target.files[0]
    const load = new FileReader()

    load.onload = event => {
      setForm(prev => ({
        ...prev,
        logo: files[0],
        logoPath: event.target.result,
      }))
    }

    if (image) load.readAsDataURL(image)

    if (!['image/png', 'image/jpeg'].includes(files[0].type)) {
      setForm(prev => ({
        ...prev,
        logo: null,
      }))

      return setLogoValidate({
        ...logoValidate,
        invalidType: 'Tipo de arquivo inválido',
        logoPath: null,
      })
    }

    setForm(prev => ({
      ...prev,
      logo: files[0],
    }))

    setLogoValidate({
      ...logoValidate,
      invalidType: '',
    })
  }

  const handleChooseFile = () => {
    inputRef.current.click()
  }

  const buscaCep = async cep => {
    const currentCep = cep?.replace(/\D/g, '')

    if (currentCep?.length !== 8) return

    try {
      const resp = await fetch(
        `https://viacep.com.br/ws/${currentCep}/json/`
      ).then(response => response?.json())

      if (!resp || resp?.erro) return

      setForm(prev => ({
        ...prev,
        city: resp?.localidade,
        uf: resp?.uf,
        street: resp?.logradouro,
        neighborhood: resp?.bairro,
      }))
    } catch (e) {
      console.log(e)
    }
  }

  const handleChangeCpf = e => {
    const { name, value } = e.target

    if (value?.length >= 15) return setMask('99.999.999/9999-99')

    setMask('999.999.999-999')
  }

  const handleValidCpfCnpj = () => {
    const { cpf_cnpj: value } = form

    const { length } = value

    if (length < 14) {
      setCpfCnpj({
        ...cpfCnpj,
        error: false,
        text: 'Digite um CPF ou CNPJ válido',
      })
    }

    // validate if cnpj
    if (length == 18) {
      if (!isCpfCnpjValid(value)) {
        return setCpfCnpj({
          ...cpfCnpj,
          error: true,
          text: 'CNPJ inválido',
        })
      }
    }

    if (!isCpfCnpjValid(value)) {
      return setCpfCnpj({
        ...cpfCnpj,
        error: true,
        text: 'CPF inválido',
      })
    }

    setCpfCnpj({
      ...cpfCnpj,
      error: false,
      text: '',
    })
  }

  useEffect(() => {
    if (form?.cpf_cnpj >= 15) return setMask('99.999.999/9999-99')
  }, [form])

  const handleStatusChange = e => {
    const { value } = e.target

    handleChange(e)

    if (value == 2) return

    setForm(prev => ({
      ...prev,
      expiration_date: '',
    }))
  }

  useEffect(() => {
    dispatch(fetchLocaleOptions()).then(data => {
      if (!data?.countries) return

      setCountries(data.countries)
      setLocales(data.locales || [])
    })
  }, [])

  // No cadastro já sugere o Brasil com os defaults dele; na edição o país vem do cliente
  useEffect(() => {
    if (form?.id || form?.country_code) return

    const country = countries.find(item => item.code === 'BR') || countries[0]

    if (!country) return

    setForm(prev => ({
      ...prev,
      country_code: country.code,
      locale: country.default_locale,
      timezone: country.default_timezone,
    }))
  }, [countries, form?.id])

  // Idioma e fuso não são editáveis: seguem sempre o padrão do país
  const handleCountryChange = e => {
    const { value } = e.target
    const country = countries.find(item => item.code === value)

    setForm(prev => ({
      ...prev,
      country_code: value,
      locale: country?.default_locale,
      timezone: country?.default_timezone,
    }))
  }

  useEffect(() => {
    if (form?.status_id != 2) return
    if (form?.expiration_date) return
    if (!trialPeriodDays) return

    const date = new Date()
    date.setDate(date.getDate() + Number(trialPeriodDays))

    setForm(prev => ({
      ...prev,
      expiration_date: format(date, 'yyyy-MM-dd'),
    }))
  }, [trialPeriodDays, form?.status_id])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="flex-end">
              {/* margin auto prende o card à esquerda, independente da logo */}
              <Grid item xs={12} sm={6} md={3} style={{ marginRight: 'auto' }}>
                <Box className={classes.regionCard}>
                  <Flag
                    code={form?.country_code}
                    width={28}
                    className={classes.regionFlag}
                  />
                  <Box className={classes.regionInfo}>
                    <Typography className={classes.regionTitle}>
                      Padrão regional
                    </Typography>
                    <TextField
                      select
                      name="country_code"
                      value={form?.country_code || ''}
                      onChange={handleCountryChange}
                      fullWidth
                      SelectProps={{
                        renderValue: value =>
                          countries.find(item => item.code === value)?.name ||
                          value,
                      }}
                    >
                      {countries.map(country => (
                        <MenuItem key={country.code} value={country.code}>
                          <Box className={classes.countryOption}>
                            <Flag code={country.code} width={20} />
                            {country.name}
                          </Box>
                        </MenuItem>
                      ))}
                    </TextField>
                    {form?.locale && (
                      <Typography className={classes.regionHint}>
                        Idioma{' '}
                        {locales.find(item => item.code === form.locale)
                          ?.name || form.locale}{' '}
                        · Fuso {form?.timezone}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Grid>

              {form?.logoPath && (
                <Grid item xs={12} sm={12} md={4}>
                  <Grid container justifyContent="flex-end">
                    <Box className={classes.boxLogo}>
                      <img
                        alt="Logo"
                        className={classes.logo}
                        src={form?.logoPath}
                      />
                    </Box>
                  </Grid>
                </Grid>
              )}

              {form?.logo && !form?.logoPath && (
                <Grid item xs={12} sm={12} md={4}>
                  <Grid container justifyContent="flex-end">
                    <Box className={classes.boxLogo}>
                      <img
                        alt="Logo"
                        className={classes.logo}
                        src={`data:image/png;base64,${form?.logo}`}
                      />
                    </Box>
                  </Grid>
                </Grid>
              )}

              <Grid item md={2}>
                <input
                  ref={inputRef}
                  name="logo"
                  type="file"
                  accept="image/*"
                  onChange={handleChangeLogo}
                  style={{ display: 'none' }}
                />
                <IconButton
                  onClick={handleChooseFile}
                  className={classes.uploadLogo}
                >
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      container
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon path={mdiProgressUpload} size={1} />
                      Upload Logo
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className={classes.logoValidate}>
                        {logoValidate?.invalidType || 'Logo (169 x 32)'}
                      </Typography>
                    </Grid>
                  </Grid>
                </IconButton>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item sm={6} md={6} xs={12}>
                <TextField
                  label="Nome"
                  name="name"
                  required
                  value={form?.name}
                  onChange={handleChange}
                  fullWidth
                  className={classes?.textField}
                />
              </Grid>

              <Grid item sm={6} md={6} xs={12}>
                <TextField
                  label="E-mail"
                  fullWidth
                  name="email"
                  value={form?.email}
                  onChange={handleChange}
                  className={classes.textField}
                  required
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item sm={5} xs={12} lg={4}>
            <ReactInputMask
              mask="99.999-999"
              name="cep"
              maskChar=""
              value={form?.cep}
              required
              onChange={handleChange}
              onBlur={() => buscaCep(form?.cep)}
            >
              {inputProps => (
                <TextField {...inputProps} label="CEP" fullWidth />
              )}
            </ReactInputMask>
          </Grid>

          <Grid item sm={12} xs={12} lg={4}>
            <TextField
              label="Rua"
              name="street"
              fullWidth
              value={form?.street}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item sm={12} xs={12} lg={4}>
            <TextField
              label="Número"
              name="number"
              fullWidth
              required
              value={form?.number}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item sm={12} xs={12} lg={4}>
              <TextField
                name="neighborhood"
                label="Bairro"
                onChange={handleChange}
                fullWidth
                required
                value={form?.neighborhood}
              />
            </Grid>

            <Grid item sm={12} xs={12} lg={4}>
              <TextField name="complement" label="Complemento" fullWidth />
            </Grid>

            <Grid item sm={12} xs={12} lg={4}>
              <TextField
                name="city"
                label="Cidade"
                onChange={handleChange}
                fullWidth
                required
                value={form?.city}
              />
            </Grid>

            <Grid item sm={12} xs={12} lg={2}>
              <InputLabel id="demo-simple-select-required-label">UF</InputLabel>
              <Select
                value={form?.uf}
                fullWidth
                name="uf"
                required
                onChange={handleChange}
              >
                <MenuItem value="">Selecione...</MenuItem>
                {ufs?.map((uf, index) => {
                  return (
                    <MenuItem key={index} value={uf}>
                      {uf}
                    </MenuItem>
                  )
                })}
              </Select>
            </Grid>

            <Grid item sm={12} xs={12} md={12} lg={3}>
              <ReactInputMask
                mask="(99) 99999-9999"
                placeholder="(__) _____-____"
                name="phone"
                maskChar=""
                value={form?.phone}
                onChange={handlePhoneChange}
              >
                {inputProps => (
                  <TextField {...inputProps} label="Telefone" fullWidth />
                )}
              </ReactInputMask>
            </Grid>

            <Grid item sm={12} xs={12} md={12} lg={3}>
              <ReactInputMask
                key={`input-cell-phone-${form?.id}`}
                mask="(99) 99999-9999"
                placeholder="(__) _____-____"
                name="cell_phone"
                maskChar=""
                value={form?.cell_phone}
                onChange={handlePhoneChange}
              >
                {inputProps => (
                  <TextField {...inputProps} label="Celular" fullWidth />
                )}
              </ReactInputMask>
            </Grid>

            <Grid item sm={12} xs={12} md={6} lg={4} xl={4}>
              <ReactInputMask
                mask={mask}
                maskChar=""
                name="cpf_cnpj"
                value={form?.cpf_cnpj}
                onChange={e => {
                  handleChangeCpf(e)
                  handleChange(e)
                }}
                onPaste={e => {
                  const digits = e.clipboardData.getData('text').replace(/[^\d]/g, '')
                  if (digits.length > 11) {
                    e.preventDefault()
                    setMask('99.999.999/9999-99')
                    const cnpj = digits.slice(0, 14).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
                    setForm(prev => ({ ...prev, cpf_cnpj: cnpj }))
                  }
                }}
                onBlur={e => handleValidCpfCnpj(e)}
                required
              >
                {inputProps => (
                  <TextField
                    {...inputProps}
                    label="CPF/CNPJ"
                    fullWidth
                    error={cpfCnpj?.error}
                    helperText={cpfCnpj?.text}
                  />
                )}
              </ReactInputMask>
            </Grid>

            <Grid item sm={12} xs={12} lg={2}>
              <InputLabel id="demo-simple-select-required-label">
                Status
              </InputLabel>
              <Select
                value={form?.status_id}
                key={`input-status_id-${form?.status_id}`}
                fullWidth
                onChange={handleStatusChange}
                name="status_id"
              >
                {statuses?.map((status, index) => (
                  <MenuItem key={index} value={status?.var_id}>
                    {status?.value}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {form?.status_id == 2 && (
              <Grid item sm={12} xs={12} lg={2}>
                <KeyboardDatePicker
                  clearable
                  label="Data de expiração"
                  name="expiration_date"
                  fullWidth
                  clearLabel="Limpar"
                  invalidDateMessage="Data inválida"
                  autoOk
                  format="dd/MM/yyyy"
                  value={
                    form?.expiration_date
                      ? parseISO(form.expiration_date)
                      : null
                  }
                  onChange={date =>
                    setForm(prev => ({
                      ...prev,
                      expiration_date: date ? format(date, 'yyyy-MM-dd') : '',
                    }))
                  }
                />
              </Grid>
            )}

            <Grid item xs={12} sm={12} md={12} style={{ marginTop: '13px' }}>
              <TextField
                placeholder="Descrição"
                name="description"
                multiline
                value={form?.description}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default FormGroupLaundry
